import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Response interceptor for consistent error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Server responded with error status
      throw new Error(error.response.data.detail || 'Server error occurred');
    } else if (error.request) {
      // Network error
      throw new Error('Network error. Please check your connection.');
    } else {
      // Other error
      throw new Error('An unexpected error occurred');
    }
  }
);

// API Functions
export const scheduleConsultation = async (formData) => {
  try {
    const response = await apiClient.post('/consultations', formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const submitContactForm = async (formData) => {
  try {
    const response = await apiClient.post('/contacts', formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Admin functions (for future use)
export const getConsultations = async () => {
  try {
    const response = await apiClient.get('/consultations');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getContacts = async () => {
  try {
    const response = await apiClient.get('/contacts');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default apiClient;